import React, { Component } from 'react';

require('smoothscroll-polyfill').polyfill();



class AppMobile extends Component {
  state={open:false, texture:false, alternative:false}
  landscapes = []

  componentWillMount(){
    var landscapes = window.landscapes
      this.setState({
        landscapes: landscapes,
        alternative: window.alternativeAnimation,
        texture: window.textureAnimation
      })
  }

  open = (num) =>{
    //Get the height it should be set to (cant animate height auto)
    const h = window.getComputedStyle(this.landscapes[num], null).getPropertyValue("height");

    var subtraction = 0
    if (this.state.open && this.state.open < num){
        const openRect = this.landscapes[this.state.open].getBoundingClientRect();
        subtraction = openRect.height - 150
    }
    const rect = this.landscapes[num].getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollTo = rect.top + scrollTop - subtraction
    window.scroll({left:0, top: scrollTo,  behavior: 'smooth' });

    if(this.state.open && this.state.open !== num ){
      this.setState({open: false})
      setTimeout(()=>{
        this.setState({open: num, height: h})
      },600)
    }else{
      this.setState({open: num, height: h})
    }


  }

  render() {
    var count = 0
    return (
      <div className="mobile">
        <div className={(this.state.open ? " open " : "") + " sankelandskaber "}>
          <ul>
            {this.state.landscapes.map((landscape,idx)=>{
              return(
                <li
                  style={{height: this.state.open === idx+1 ? this.state.height : null}}
                  className={this.state.open === idx+1 ? "active" : ""}
                  onClick={()=>this.open(idx+1)}>
                  <div className="info">
                    <img className="icon" src={landscape.icon} alt="" draggable="false" />
                    <h2>{landscape.name}</h2>
                    <p>{landscape.description}</p>
                  </div>
                  <ul
                    ref={r=>this.landscapes[idx+1] = r}
                  >
                    {
                      landscape.subLandscapes.map((subLandscape, subIDX)=>{
                              count += 1
                        return(
                          <li

                            className="sub">
                            <a
                              key={subLandscape.name}
                              href={subLandscape.path}>
                              <div className="info">
                                <h2>{subLandscape.name}</h2>
                                <p>{subLandscape.description}</p>
                              </div>
                            </a>
                            <Image className="landscape-background" src={subLandscape.image} alt="" draggable="false" ></Image>
                          </li>
                        )
                      })
                    }
                  </ul>
                </li>
                      )}
                    )}
                      </ul>
                    </div>
                    </div>
                  )
              }




}

export default AppMobile;







class Image extends React.Component {
state={
  loaded:false
}

render() {


  return (
      <img
      {...this.props}
      ref={(i=>{
        if(i && i.complete && !this.state.loaded){
          this.setState({loaded:true})
        }
      })}
      className={
        this.props.className + (this.props.animation ? " reveal-animation " : " reveal ") +
        (this.state.loaded ? (this.props.animation ? " revealed " : " loaded ") : "")
        }
      onLoad={(()=>{
        this.setState({loaded:true})
        if (this.props.onLoad) this.props.onLoad()
        })}

     />
  );
}
}



// WEBPACK FOOTER //
// ./src/LandscapesMenuMobile.js